import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Unit } from '../models/unit';

@Injectable({
  providedIn: 'root'
})
export class UnitService {
  apiEndpoint: string="";
  baseApiUrl: any;
  apiUniqueId: string = 'unit/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E';

  constructor(private httpService: HttpWrapperService, 
    private http: HttpClient,
    private configService: ConfigService) { 
      this.apiEndpoint = this.configService.getConfigValue("apiEndpoint");
      this.apiEndpoint += this.apiUniqueId;
    }
    getAllUnit(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<any>>{ 
      return this.httpService.get(this.apiEndpoint + '/getAllUnits?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                   
        if (result.Success && result.Success ) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }

    viewUnit(UnitID?: string): Observable<Array<Unit>> {
      return this.httpService.get(this.apiEndpoint + '/viewUnit/' + (UnitID ? UnitID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    saveUnit(units: Unit): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/saveUnit/', units).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    deleteUnit(UnitID?: string): Observable<any> {
      return this.httpService.post(this.apiEndpoint + '/deleteUnit/' + (UnitID ? UnitID : '00000000-0000-0000-0000-000000000000'), UnitID).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    checkDuplication(UnitID?: string,UnitPrefix?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkDuplication?&UnitID=' + (UnitID ? UnitID : '00000000-0000-0000-0000-000000000000')+'&UnitPrefix=' + (UnitPrefix ? UnitPrefix : '')).pipe(map((result: any) => {
          return result; 
      }));
    }  
  }

